import { render, staticRenderFns } from "./attrSpecList.vue?vue&type=template&id=a17ca39c&scoped=true"
import script from "./attrSpecList.vue?vue&type=script&lang=js"
export * from "./attrSpecList.vue?vue&type=script&lang=js"
import style0 from "./attrSpecList.vue?vue&type=style&index=0&id=a17ca39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17ca39c",
  null
  
)

export default component.exports